/* src/app/shared/components/menu/menu-horizontal.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.menu.horizontal {
  width: 100%;
  background-color: #004791;
}
.menu.horizontal .menu-content-wrapper {
  padding: 0 1em;
  margin: 0 auto;
  width: 100%;
}
@media screen and (min-width: 64rem) {
  .menu.horizontal .menu-content-wrapper {
    padding: 0;
    width: 48rem;
  }
}
.menu.horizontal .menu-content-wrapper > .menu-content > .menu-items {
  flex-wrap: wrap;
}
.menu.horizontal .menu-items,
.menu.horizontal .sub-menu-items {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.menu.horizontal .menu-items {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
}
.menu.horizontal .menu-items.vertical {
  flex-direction: column;
  align-items: stretch;
}
.menu.horizontal .menu-items > .menu-item {
  min-width: 5em;
  text-align: center;
  position: relative;
}
.menu.horizontal .menu-items > .menu-item > .mat-mdc-button.active {
  position: relative;
}
.menu.horizontal .menu-items > .menu-item > .mat-mdc-button.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #64a70b;
}
.menu.horizontal .menu-items > .menu-item.has-sub-menu > .mat-mdc-button {
  padding-right: 2em;
}
.menu.horizontal .menu-items > .menu-item.has-sub-menu > .mat-mdc-button::after {
  font-family: "Material Icons";
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0.5em;
  font-size: 1.25em;
  transform: translateZ(0);
  color: currentColor;
  opacity: 0.54;
  content: "\e313";
  font-size: 1em;
}
.menu.horizontal .menu-items > .menu-item > .sub-menu-items {
  position: absolute;
  top: 100%;
  left: 0;
}
.menu.horizontal .menu-items > .menu-item > .sub-menu-items .menu-item {
  position: relative;
}
.menu.horizontal .menu-items > .menu-item > .sub-menu-items .menu-item > .mat-mdc-button {
  background-color: white;
}
.menu.horizontal .menu-items > .menu-item > .sub-menu-items .menu-item .sub-menu-items {
  position: absolute;
  top: 0;
  left: 100%;
}
.menu.horizontal .menu-items > .menu-item > .sub-menu-items {
  visibility: hidden;
  opacity: 0;
  transform: translateY(-2em);
  z-index: -1;
  transition:
    all 0.225s ease-in-out 0s,
    visibility 0s linear 0.225s,
    z-index 0s linear 0.01s;
}
.menu.horizontal .menu-items > .menu-item:hover > .sub-menu-items {
  visibility: visible;
  opacity: 1;
  z-index: 1;
  transform: translateY(0%);
  transition-delay:
    0s,
    0s,
    0.225s;
}
.menu.horizontal .menu-items > .menu-item .menu-item > .sub-menu-items {
  visibility: hidden;
  opacity: 0;
  transform: translateX(-2em);
  z-index: -1;
  transition:
    all 0.225s ease-in-out 0s,
    visibility 0s linear 0.225s,
    z-index 0s linear 0.01s;
}
.menu.horizontal .menu-items > .menu-item .menu-item:hover > .sub-menu-items {
  visibility: visible;
  opacity: 1;
  z-index: 1;
  transform: translateX(0%);
  transition-delay:
    0s,
    0s,
    0.225s;
}
.menu.horizontal .menu-items .sub-menu-items {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.menu.horizontal .menu-items .sub-menu-items .menu-item.has-sub-menu > .mat-mdc-button {
  padding-right: 2em;
  background-color: white;
}
.menu.horizontal .menu-items .sub-menu-items .menu-item.has-sub-menu > .mat-mdc-button::after {
  font-family: "Material Icons";
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0.5em;
  font-size: 1.25em;
  transform: translateZ(0);
  color: currentColor;
  opacity: 0.54;
  content: "\e315";
  font-size: 1em;
}
.menu.horizontal .menu-items .sub-menu-items .menu-item .mat-mdc-button {
  width: 100%;
  text-align: left;
  padding-right: 2em;
}
/*# sourceMappingURL=menu-horizontal.component.css.map */
